import { Box, Dialog, DialogTitle } from "@mui/material";
import * as productBatchSlice from "../../product-batch/product-batch.slice";
import { useAppSelector } from "../../../../app/hooks";
import useProductBatches from "../../../../hooks/use-product-batches";
import Loader from "../../../../components/loader";
import ProductBatchTable from "./product-batch-table";
import FormCloseButton from "../../../../components/form-controls/form-close-button";

const style = {
    p: 2,
};

interface ProductBatchModalProps {
    readonly productId: number;
    readonly onClose: () => void;
}

const ProductBatchModal: React.FC<ProductBatchModalProps> = ({ productId, onClose }) => {
    // const dispatch = useAppDispatch();
    // const loggedInUserDetails = useAppSelector(selectLoggedInUser);
    // const loggedInUser = loggedInUserDetails?.user;
    // const [showProductBatchForm, setShowProductBatchForm] = useState(false);
    const isLoading = useAppSelector(productBatchSlice.selectIsLoading);

    const [productBatches] = useProductBatches(productId);

    // const handleSubmit = (data: ProductBatchRequest) => {
    //     loggedInUser && dispatch(productBatchSlice.createBatch({ ...data, })).then(resp => {
    //         if (resp.meta.requestStatus === 'fulfilled') {
    //             setShowProductBatchForm(false);
    //         }
    //     });
    // };

    return (
        <Dialog open={true} onClose={onClose} sx={style} fullWidth maxWidth="lg">
            <DialogTitle>Product Batches</DialogTitle>
            <Box sx={{ p: 5 }}>
                <FormCloseButton onClose={onClose} />
                {isLoading &&
                    <Loader />
                }
                {productBatches &&
                    <>
                        {/* <Box sx={{ mb: "12px" }}>
                            <CreateButton variant="contained" onClick={() => setShowProductBatchForm(true)} style={{ marginBottom: "12px" }}>Add Product Batch</CreateButton>
                        </Box> */}
                        <ProductBatchTable productBatches={productBatches} />
                        {/* {showProductBatchForm &&
                            <ProductBatchForm productBatch={undefined} editable={true} onClose={() => setShowProductBatchForm(false)} onSubmit={handleSubmit} />
                        } */}
                    </>
                }
            </Box>
        </Dialog>
    )
}

export default ProductBatchModal;